<template>
  <div>
    <div class="data-sets" :class="{ 'data-sets-fixed': fixed }">
      <div class="data-set-row" v-for="row of currentDataSets" :key="row.id" :style="{ border: `3px solid ${row.color}` }">
        <div class="checkbox">
          <b-checkbox  @change="fetchDataSet(row, $event)" switch>{{ row.title }}</b-checkbox>
        </div>
        <b-icon-gear-fill @click="openSettings(row)" class="data-set-icon" />
      </div>
    </div>

    <b-modal id="data-set-settings" title="Data Set Settings" hide-footer centered>
      <b-form style="text-align: left" @submit.prevent="">
        <b-form-group label="Search Programs:" label-for="program" :invalid-feedback="programInvalid" :state="programState">
          <search-list
            name="program"
            type="search"
            :list="program.list"
            @select-thing="selectItem($event, `program`)"
            @find-thing="searchPrograms($event, 'program')"
            itemName="fileName"
            required
            :state="programState"
          />
        </b-form-group>

        <b-form-group label="Select a Tab:">
          <b-form-radio-group v-model="selectedTab" :options="tabOptions" name="radio-options"></b-form-radio-group>
        </b-form-group>

        <b-form-group label="Show Applied apps or Projected apps:">
          <b-form-radio-group v-model="appliedVsProj" :options="['Applied', 'Projected']" name="apps"></b-form-radio-group>
        </b-form-group>

        <!-- <b-form-group label="Dataset Color:">
          <b-input type="color" v-model="currentDataset.color"></b-input>
        </b-form-group> -->
        <b-button type="submit" size="sm" @click="saveSettings">Save</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { search } from "../modules/api";
import { randomId } from "../modules/utils";

import { BIconGearFill } from "bootstrap-vue";
import SearchList from "./SearchList.vue";
import { program } from "../modules/PC";

export default {
  name: "dataset-header",
  components: { BIconGearFill, SearchList },
  data() {
    return {
      fixed: false,
      currentDataset: {},
      program: {
        list: [],
        value: "",
        selected: null,
        data: {}
      },
      selectedTab: "",
      appliedVsProj: "Applied"
    };
  },
  methods: {
    async saveSettings() {
      let dataSet = this.currentDataset;
      dataSet.tabId = this.selectedTab;
      dataSet.programId = this.program.data.externalId;
      dataSet.appliedVsProj = this.appliedVsProj;
      if (this.appliedVsProj === "Projected") {
        let tabData = this.program.data.tabs.find(x => x.id === this.selectedTab);
        dataSet.tabData = tabData;
      } else {
        let apps = await program.application.byTab([this.selectedTab]);
        if (apps.data.success) {
          let tabData = apps.data.tabs[0];
          if (!tabData) {
            this.notify({
              variant: "warn",
              message: "There are no applications logged for the tab you selected."
            });
          }
          dataSet.tabData = tabData;
        }
      }
      this.updateDataSet({ id: this.currentDataset.id, dataSet });

      this.$bvModal.hide("data-set-settings");
    },
    openSettings(row) {
      this.currentDataset = row;

      this.$bvModal.show("data-set-settings");
    },
    async fetchDataSet(dataSet, val) {
      let exists = this.dataSetsWithData.find(x => x.id === dataSet.id);
      if (exists) {
        this.dataSetActiveState({
          id: dataSet.id,
          val
        });
        return;
      }

      if (dataSet.id === "currentSelection") {
        this.setDataSetsWithData([
          {
            id: dataSet.id,
            color: dataSet.color,
            data: this.allRecords
          }
        ]);
        this.dataSetActiveState({
          id: dataSet.id,
          val
        });
        return;
      }
      let params = {};
      let keys = ["businessName", "locationName", "plotName", "cropName", "limit"];
      if (!dataSet.ignoreVariety) {
        keys.push("varietyName");
      }
      if (dataSet.currentYear) {
        params.currentYear = true;
      }
      for (let key of keys) {
        if (dataSet[key]) {
          params[key] = dataSet[key];
        }
      }

      let records = await search.records("", params);

      if (records.data.success && records.data.orders.length > 0) {
        records.data.orders.forEach(x => {
          x.setId = x.setId || randomId();
        });
      } else {
        return this.notify({
          message: "the dataset returned no records",
          variant: "warn"
        });
      }

      this.setDataSetsWithData([
        {
          id: dataSet.id,
          color: dataSet.color,
          data: records.data.orders
        }
      ]);
      this.dataSetActiveState({
        id: dataSet.id,
        val
      });
    },
    setFixed(evt) {
      if (evt.target.scrollTop > 100) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
    },
    async selectItem(id, name) {
      this[name].selected = this[name].list.find(x => x.id === id);
      this[name].list = [];

      let res = await program.program.get(id);
      if (!res.data.success) {
        this.notify({
          variant: "warn",
          message: "Failed to find that program."
        });
        return;
      }

      this.program.data = res.data.program;
    },
    async searchPrograms(string, name) {
      this[name].selected = "";
      if (string.length < 3) {
        return;
      }
      // wait till the user finishes typing
      clearTimeout(this.typingTimer);
      await this.asyncTypingTimer(500);

      let res = await program.search.string(string, true);
      if (res.data.success) {
        this.program.list = res.data.programs.map(x => ({ ...x, id: x.externalId }));
      }
    },
    asyncTypingTimer(time) {
      return new Promise(resolve => {
        this.typingTimer = setTimeout(() => {
          resolve();
        }, time);
      });
    },
    ...mapActions(["notify"]),
    ...mapMutations(["setDataSetsWithData", "dataSetActiveState", "updateDataSet"])
  },
  computed: {
    programInvalid() {
      if (this.program.selected === null) {
        return "";
      }
      if (!this.program.selected) {
        return "you have not selected an program.";
      }
      return "";
    },
    programState() {
      if (this.program.selected === null) {
        return null;
      }
      if (!this.program.selected) {
        return false;
      }
      return true;
    },
    tabOptions() {
      if (!this.program.data.tabs) {
        return [];
      }
      return this.program.data.tabs.map(tab => ({ text: tab.name || tab.crop, value: tab.id }));
    },
    ...mapGetters(["allRecords", "currentDataSets", "dataSetsWithData"])
  },
  mounted() {
    let page = document.getElementById("main-graph-scroll");

    page.addEventListener("scroll", this.setFixed);
  },
  beforeDestroy() {
    let page = document.getElementById("main-graph-scroll");

    page.removeEventListener("scroll", this.setFixed);
  }
};
</script>

<style lang="scss" scoped>
.data-sets {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-auto-rows: auto;
  grid-gap: 0.3em;
  padding: 0.3em;
  box-shadow: 0px 0px 2px darkgray;
  margin-bottom: 0.3em;
  text-align: left;
  border-radius: 0.2em;
  overflow-y: auto;
  background-color: white;
  max-height: 18em;
}

.data-sets-fixed {
  position: fixed;
  top: 3em;
  width: 97.5%;
  box-shadow: 0px 0px 4px rgb(150, 149, 149);
  height: 8em;
}

.data-set-row {
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 0.5em;
  text-align: left;
  border: 1px solid #ccc;
  display: grid;
  grid-template-columns: 1fr 2em;
  min-height: 4em;
  max-height: 5.5em;
  overflow: auto;
}

.data-set-icon {
  color: #5c5c5c;
  cursor: pointer;
  margin-left: 0.45em;
  margin-top: 1em;
  font-size: 1.3em;
}
</style>
